import type {
    FooterCountryLink,
    FooterPaymentSlot,
    FooterSocialLink
} from './types'
import { FOOTER_URLS } from './urls'

export const FOOTER_SOCIAL_LINKS: FooterSocialLink[] = [
    {
        href: FOOTER_URLS.instagram,
        title: 'INSTAGRAM',
        network: 'instagram'
    },
    {
        href: FOOTER_URLS.facebook,
        title: 'FACEBOOK',
        network: 'facebook'
    },
    {
        href: FOOTER_URLS.pinterest,
        title: 'PINTEREST',
        network: 'pinterest'
    },
    {
        href: FOOTER_URLS.linkedin,
        title: 'LINKEDIN',
        network: 'linkedin'
    },
    {
        href: FOOTER_URLS.tiktok,
        title: 'TIKTOK',
        network: 'tiktok'
    },
    {
        href: FOOTER_URLS.youtube,
        title: 'YOUTUBE',
        network: 'youtube'
    }
]

export const FOOTER_COUNTRY_LINKS: FooterCountryLink[] = [
    {
        href: FOOTER_URLS.chile,
        title: 'CHILE',
        country: 'chile',
        selected: true
    },
    { href: FOOTER_URLS.peru, title: 'PERU', country: 'peru' },
    { href: FOOTER_URLS.colombia, title: 'COLOMBIA', country: 'colombia' },
    { href: FOOTER_URLS.bolivia, title: 'BOLIVIA', country: 'bolivia' },
    { href: FOOTER_URLS.mexico, title: 'MEXICO', country: 'mexico' }
]

export const FOOTER_PAYMENT_SLOTS: FooterPaymentSlot[] = [
    {
        id: 'webpay',
        label: 'Webpay Plus',
        src: '/footer/payments/webpay-plus.png',
        width: 158,
        height: 46
    },
    {
        id: 'webpay-oneclick',
        label: 'Webpay Oneclick',
        src: '/footer/payments/webpay-oneclick.png',
        width: 172,
        height: 46
    },
    {
        id: 'venti',
        label: 'venti',
        src: '/footer/payments/venti.png',
        width: 96,
        height: 40
    },
    {
        id: 'mercado-pago',
        label: 'Mercado Pago',
        src: '/footer/payments/mercado-pago.png',
        width: 130,
        height: 36
    }
]
